'use client';

import classnames from 'classnames';
import { IoBookmark, IoFlag } from 'react-icons/io5';

import type { BaseComponentProps } from '../../../../base-component.types';
import { Button } from '../../../../button';

import styles from './AssessmentIndexItem.module.scss';

type AssessmentIndexItemProps = BaseComponentProps & {
  index: number;
  response?: 'correct' | 'incorrect' | 'unanswered' | 'pending';
  flagged?: boolean;
  bookmarked?: boolean;
  onClick: () => void;
};

function AssessmentIndexItem({
  style,
  className,
  index,
  response,
  flagged,
  bookmarked,
  onClick,
  testId,
}: AssessmentIndexItemProps) {
  const content = (
    <>
      <span>{index + 1}</span>
      {flagged && <IoFlag className={styles['flag']} aria-hidden="true" />}
      {bookmarked && (
        <IoBookmark className={styles['bookmark']} aria-hidden="true" />
      )}
    </>
  );

  const buttonClassName = classnames(
    styles['main'],
    response && styles[`main--${response}`],
    className,
  );

  // An answered question is a solid button whatever the answer was; one still waiting
  // is outlined, so the two read apart at a glance across the whole index.
  const isAnswered =
    response === 'correct' ||
    response === 'incorrect' ||
    response === 'pending';

  return (
    <Button
      style={style}
      className={buttonClassName}
      variant={isAnswered ? 'primary' : 'outline-primary'}
      testId={testId}
      onClick={onClick}
    >
      {content}
    </Button>
  );
}

export { AssessmentIndexItem };
